import React from 'react'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import ContentLoader from 'react-content-loader'
import { LoaderContainer, PlaceholderData } from './mixins'

const Component = () => {
  const { isMobile } = useWindowSize()

  if (isMobile) {
    return null
  }

  return (
    <LoaderContainer>
      <PlaceholderData>
        <ContentLoader
          speed={2}
          width="423"
          height={176}
          viewBox="0 0 423 176"
          backgroundColor="#f3f3f3"
          foregroundColor="#d4d4d4"
        >
          <rect x="16" y="16" rx="8" ry="8" width={423 * 0.65} height="48" />
          <rect x="20" y="80" rx="4" ry="4" width="16" height="16" />
          <rect x="44" y="80" rx="4" ry="4" width={423 * 0.3} height="16" />
          <rect x="16" y="112" rx="8" ry="8" width={423 * 0.65} height="48" />
        </ContentLoader>
      </PlaceholderData>
    </LoaderContainer>
  )
}

export default Component
